var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navbar-container d-flex content align-items-center"
  }, [_c('ul', {
    staticClass: "nav navbar-nav d-xl-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('b-link', {
    staticClass: "nav-link",
    on: {
      "click": _vm.toggleVerticalMenuActive
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "MenuIcon",
      "size": "21"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
  }), _c('b-navbar-nav', {
    staticClass: "nav align-items-center ml-auto"
  }, [_c('b-nav-item', {
    staticClass: "text-white mr-1",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.reloadPage($event);
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "size": "21",
      "icon": "RefreshCwIcon"
    }
  })], 1), _c('dark-Toggler', {
    staticClass: "d-none d-md-block"
  }), _c('user-dropdown')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }